import React from "react"
import PropTypes from "prop-types"
import ClassNames from "classnames"
import ValidationMixin from "@cirrus/legacy/app-components/validations/validation-mixin/index.jsx"
import styles from "./styles.less"
import SuggestInput from "../autosuggest-input/index.jsx"
import $ from "jquery"
import appStorage from "@cirrus/legacy/app-components/app-settings/index.es6"
import createReactClass from "create-react-class"

var LabelInput = createReactClass({
  propTypes: {
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    loadPromise: PropTypes.func.isRequired,
    getSuggestionValue: PropTypes.func.isRequired,
    getSuggestionId: PropTypes.func.isRequired,
    filterList: PropTypes.func,
    isOpen: PropTypes.bool,
  },
  getInitialState: function () {
    return {
      suggestions: [],
      valueLength: 0,
      inputStyle: null,
      buttonStyle: {},
      inputValue: "",
      renderAll: false,
    }
  },
  handleChange(e, value) {
    this.props.onChange && this.props.onChange(value)
    this.setState({ inputValue: "" })
  },
  measureLabels() {
    var that = this
    if (!this.props.isOpen) {
      return
    }

    if (this.state.valueLength == this.props.value.length) return

    if (!this.refs.container || !this.refs.list || !this.refs.list.offsetWidth) {
      this.setState({
        inputStyle: { paddingLeft: "5px" },
        valueLength: this.props.value.length,
      })
      return
    }

    var rows = []
    var countWidth = 0
    Array.from(this.refs.list.children).forEach((child) => {
      if (countWidth + child.offsetWidth >= that.refs.container.offsetWidth - 23) {
        rows.push(countWidth)
        countWidth = child.offsetWidth
        return
      }

      countWidth = countWidth + child.offsetWidth
    })

    rows.push(countWidth)

    this.setState({
      inputStyle: {
        height: this.refs.list.offsetHeight + 25 + "px",
        paddingTop: this.refs.list.offsetHeight - 25 + "px",
        paddingLeft: rows[rows.length - 1] + 5 + "px",
      },
      buttonStyle: {
        lineHeight: this.refs.list.offsetHeight + 10 + "px",
      },
      valueLength: this.props.value.length,
    })
  },
  initJQueryEvents() {
    var $button = $(this.refs.dropDownButton)
    var $input = $(this.refs.container).find("input")
    $button.hover(
      function () {
        if ($input.is(":focus")) return
        $input.addClass(styles.hoverInput)
      },
      function () {
        if ($input.is(":focus")) return
        $input.removeClass(styles.hoverInput)
      },
    )

    $input.hover(
      function () {
        if ($input.is(":focus")) return
        $button.addClass(styles.hoverButton)
      },
      function () {
        if ($input.is(":focus")) return
        $button.removeClass(styles.hoverButton)
      },
    )

    $input.focus(function () {
      $input.addClass(styles.hoverInput)
      $button.addClass(styles.hoverButton)
    })

    $input.blur(function () {
      $input.removeClass(styles.hoverInput)
      $button.removeClass(styles.hoverButton)
    })
  },
  componentWillMount() {
    window.addEventListener("click", this.changeRenderAll)
  },
  componentWillUnmount() {
    window.removeEventListener("click", this.changeRenderAll)
  },
  componentDidUpdate() {
    this.measureLabels()
  },
  componentDidMount() {
    this.measureLabels()
    this.initJQueryEvents()
  },
  renderSuggestion(suggestion) {
    return (
      <span>
        {this.props.getSuggestionValue(suggestion)}
        {this.props.getSuggestionId(suggestion) == null
          ? " (" + appStorage.translationFunction("General.LabelEditor:NewLabel") + ")"
          : null}
      </span>
    )
  },
  renderSectionTitle(section) {
    return section.title ? <strong>{section.title}</strong> : null
  },
  getSectionSuggestions(section) {
    return section.suggestions
  },
  onDelete(id) {
    var index = this.props.value.map((item) => item.id).indexOf(id)

    if (index == -1) return

    this.props.onDelete && this.props.onDelete(this.props.value[index])
  },
  handleDropDownClick() {
    this.onSuggestionsUpdateRequested({ value: "", renderAll: true })
  },
  onSuggestionsUpdateRequested({ value, renderAll }) {
    var that = this
    this.props.loadPromise &&
      this.props.loadPromise(value).then(function (list) {
        if (!Array.isArray(list)) list = list.data

        if (that.props.filterList) list = that.props.filterList(list, value)

        that.setState(
          {
            suggestions: list,
            renderAll: renderAll ? renderAll : that.state.renderAll,
          },
          () => {
            if (renderAll)
              $("." + styles.container)
                .find("input")
                .focus()
          },
        )
      })
  },
  onInputChange(event, newValue) {
    this.setState({ inputValue: newValue })
  },
  changeRenderAll(e) {
    if ($(e.target).attr("class") == styles.dropDownButton) return
    if (this.state.renderAll) this.setState({ renderAll: false })
  },
  shouldComponentUpdate(nextProps, nextState) {
    if (!nextState.renderAll && this.state.renderAll) return false
    return true
  },
  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] })
  },
  render() {
    return (
      <div ref="container" className={ClassNames(styles.container, this.props.className)}>
        <SuggestInput
          placeholder={this.props.placeholder}
          onChange={this.handleChange}
          getSuggestionValue={this.props.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          inputStyle={this.state.inputStyle}
          multiSection={true}
          renderSectionTitle={this.renderSectionTitle}
          getSectionSuggestions={this.getSectionSuggestions}
          onSuggestionsUpdateRequested={this.onSuggestionsUpdateRequested}
          suggestions={this.state.suggestions}
          inputValue={this.state.inputValue}
          onInputChange={this.onInputChange}
          shouldRenderSuggestions={this.state.renderAll}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        />
        <div
          ref="dropDownButton"
          onClick={this.handleDropDownClick}
          className={styles.dropDownButton}
          style={this.state.buttonStyle}
        />
        {this.props.value.length ? (
          <div className={styles.representation}>
            <ul ref="list" className={styles.list}>
              {this.props.value.map((item) => (
                <li className={styles.item} key={this.props.getSuggestionId(item)}>
                  <div className={styles.value}>
                    <span>{this.props.getSuggestionValue(item)}</span>
                  </div>
                  <i
                    onClick={this.onDelete.bind(this, this.props.getSuggestionId(item))}
                    className={ClassNames(styles.itemDelete, "icon icon-circle-remove")}
                  />
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    )
  },
})

export default ValidationMixin(LabelInput)
